import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { isDefined } from '@fi-shared/utils';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-access-right-filters-quick-selection',
    template: `
        <fi-select-search
          [items]="filters"
          [label]="quickChoiceTitleId | fiAppText"
          [(ngModel)]="selectedFilterId"
          (ngModelChange)="selectedFilterIdChange()"
          [displayValue]="selectDisplayValue"
          [filterBy]="selectDisplayValue"
          [matOptionValueProperty]="optionValueProperty"
          [showDeleteItemButton]="true"
          (onDeleteButtonClick)="deleteQuickChoice($event)"
          [showEditItemButton]="true"
          (onEditButtonClick)="editQuickChoice($event)"
          [required]="isRequired"
          [disabled]="isDisabled"
          [panelClass]="panelClass"
          selectSuffixIconClassName="fa-sharp fa-solid fa-caret-down"
          [isFormFieldNewDefaultStyle]="isFormFieldNewDefaultStyle"
          [errorText]="'access_rights.choose_selection' | fiAppText"
          >
        </fi-select-search>
        
        @if (!useThumbThacks) {
          <button
            mat-raised-button
            class="BrandedBackgroundColor"
            [disabled]="isSetDefaultFilterDisabled()"
            (click)="setFilterAsDefault()"
            >
            {{ 'document.make_template_my_default' | fiAppText }}
          </button>
        }
        `,
    styleUrls: ['./access-right-filters-quick-selection.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-access-right-filters-quick-selection' },
    providers: [{ provide: FiComponentsContainer, useExisting: AccessRightFiltersQuickSelectionComponent }],
    standalone: false,
})
export class AccessRightFiltersQuickSelectionComponent extends FiComponentsContainer {
    @Input() selectedFilterId: number;
    @Input() filters: any[];
    @Input() useThumbThacks: boolean = false;
    @Input() selectedFilter;
    @Input() quickChoiceTitleId: string;
    @Input() isRequired: boolean = true;
    @Input() isFormFieldNewDefaultStyle: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() panelClass: string;
    @Output() onDeleteQuickChoice = new EventEmitter();
    @Output() onEditQuickChoice = new EventEmitter();
    @Output() onSetFilterAsDefault = new EventEmitter<void>();
    @Output() onSelectedFilterIdChange = new EventEmitter<number>();
    readonly selectDisplayValue: string = 'Name';
    readonly optionValueProperty: string = 'Id';

    selectedFilterIdChange(): void {
        this.onSelectedFilterIdChange.emit(this.selectedFilterId);
    }

    isSetDefaultFilterDisabled(): boolean {
        return isDefined(this.selectedFilter) ? this.selectedFilter.IsDefault : true;
    }

    deleteQuickChoice($event): void {
        this.onDeleteQuickChoice.emit($event);
    }

    editQuickChoice($event): void {
        this.onEditQuickChoice.emit($event);
    }

    setFilterAsDefault(): void {
        this.onSetFilterAsDefault.emit();
    }
}
